import { render, staticRenderFns } from "./chart-total.vue?vue&type=template&id=05ea20a2&scoped=true&"
import script from "./chart-total.vue?vue&type=script&lang=ts&"
export * from "./chart-total.vue?vue&type=script&lang=ts&"
import style0 from "./chart-total.vue?vue&type=style&index=0&id=05ea20a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea20a2",
  null
  
)

export default component.exports